export const TEXT_QUICK_ADD = [
  { id: 'heading', nameKey: 'addHeading', sizeRatio: 0.085, previewSize: 22, style: { bold: true } },
  { id: 'subheading', nameKey: 'addSubheading', sizeRatio: 0.05, previewSize: 16, style: { bold: true } },
  { id: 'body', nameKey: 'addBody', sizeRatio: 0.032, previewSize: 13, style: {} },
];

export const TEXT_LOOKS = [
  { id: 'clean', nameKey: 'lookClean', style: { fill: '#ffffff', bold: true } },
  {
    id: 'glass',
    nameKey: 'lookGlass',
    style: { fill: '#ffffff', bold: true },
    background: { fill: '#ffffff', opacity: 0.22, paddingEm: 0.45, radiusEm: 0.35, blurEm: 0.6 },
  },
  {
    id: 'highlight',
    nameKey: 'lookHighlight',
    style: { fill: '#111111', bold: true },
    background: { fill: '#FDBF47', paddingEm: 0.18, radiusEm: 0.08 },
  },
  {
    id: 'band',
    nameKey: 'lookBand',
    style: { fill: '#ffffff' },
    background: { fill: '#000000', opacity: 0.6, paddingEm: 0.45, radiusEm: 0 },
  },
];

export const TEXT_BLOCKS = [
  {
    id: 'keyMessage',
    nameKey: 'styleKeyMessage',
    sampleKey: 'sampleKeyMessage',
    sizeRatio: 0.085,
    previewSize: 15,
    widthRatio: 0.84,
    anchor: { x: 'center', y: 0.68 },
    style: { bold: true, fill: '#ffffff', align: 'center' },
    shadow: { color: '#000000', opacity: 0.5, blurEm: 0.2, offsetEm: 0.03 },
  },
  {
    id: 'campaignTag',
    nameKey: 'styleCampaignTag',
    sampleKey: 'sampleCampaignTag',
    sizeRatio: 0.035,
    previewSize: 13,
    fitWidth: true,
    anchor: { x: 'left', y: 'top' },
    style: { bold: true },
    background: { fill: '#FDBF47', paddingEm: 0.35, radiusEm: 0.25 },
  },
  {
    id: 'event',
    nameKey: 'styleEvent',
    sampleKey: 'sampleEvent',
    sizeRatio: 0.035,
    previewSize: 12,
    fitWidth: true,
    anchor: { x: 'right', y: 'top' },
    style: { bold: true, fill: '#ffffff', align: 'right' },
    letterSpacingEm: 0.04,
    shadow: { color: '#000000', opacity: 0.5, blurEm: 0.2, offsetEm: 0.03 },
  },
  {
    id: 'source',
    nameKey: 'styleSource',
    sampleKey: 'sampleSource',
    sizeRatio: 0.018,
    previewSize: 10,
    fitWidth: true,
    anchor: { x: 'left', y: 'bottom' },
    style: { fill: '#ffffff' },
    shadow: { color: '#000000', opacity: 0.6, blurEm: 0.3, offsetEm: 0 },
  },
];

export const buildTextStyleOptions = (preset, fontSize) => {
  const options = { ...preset.style, fontSize };
  if (preset.letterSpacingEm) {
    options.letterSpacing = Math.round(fontSize * preset.letterSpacingEm);
  }
  if (preset.background) {
    options.background = {
      enabled: true,
      fill: preset.background.fill,
      padding: Math.round(fontSize * preset.background.paddingEm),
      cornerRadius: Math.round(fontSize * preset.background.radiusEm),
      opacity: preset.background.opacity ?? 1,
      blur: Math.round(fontSize * (preset.background.blurEm || 0)),
    };
  }
  if (preset.shadow) {
    const offset = Math.round(fontSize * preset.shadow.offsetEm);
    options.shadow = {
      enabled: true,
      color: preset.shadow.color,
      blur: Math.round(fontSize * preset.shadow.blurEm),
      offsetX: offset,
      offsetY: offset,
      opacity: preset.shadow.opacity,
    };
  }
  if (preset.outline) {
    options.outline = {
      enabled: true,
      color: preset.outline.color,
      width: Math.max(1, Math.round(fontSize * preset.outline.widthEm)),
    };
  }
  return options;
};
